// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeoplePersonGearSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 8c0-2.213 1.787-4 4-4s4 1.787 4 4-1.787 4-4 4-4-1.787-4-4zm11.666 12.788a.27.27 0 0 1-.224.193c-.303.027-.61.027-.917-.002-.118-.011-.206-.11-.23-.226a1.497 1.497 0 0 0-2.263-.973c-.1.062-.232.066-.322-.012a4.971 4.971 0 0 1-.632-.664.27.27 0 0 1-.014-.296 1.502 1.502 0 0 0-.852-2.139.27.27 0 0 1-.193-.224 4.963 4.963 0 0 1 .002-.917c.011-.119.11-.206.226-.23a1.497 1.497 0 0 0 .973-2.263c-.062-.101-.066-.233.012-.322.203-.233.426-.444.664-.632a.27.27 0 0 1 .296-.015 1.5 1.5 0 0 0 2.139-.852.27.27 0 0 1 .224-.193c.303-.027.61-.027.917.003.118.01.206.109.23.225a1.498 1.498 0 0 0 2.263.974c.101-.063.233-.066.322.012.233.203.444.425.632.664a.27.27 0 0 1 .014.296 1.5 1.5 0 0 0 .852 2.139.27.27 0 0 1 .194.224c.027.303.027.61-.003.917-.011.118-.109.206-.225.23a1.498 1.498 0 0 0-.974 2.263c.063.1.066.232-.012.322a4.971 4.971 0 0 1-.664.632.27.27 0 0 1-.296.014 1.5 1.5 0 0 0-2.139.852zm.123-6.623a2 2 0 1 0-1.58 3.673 2 2 0 0 0 1.58-3.673zm-7.01-.126a2.403 2.403 0 0 1-1.382.836c-.186.038-.343.178-.361.367a7.952 7.952 0 0 0-.004 1.467.432.432 0 0 0 .309.36A2.4 2.4 0 0 1 10.904 20H2.5a.5.5 0 0 1-.5-.5v-.963C2 15.61 7.333 14 10 14c.24 0 .502.013.78.039z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeoplePersonGearSolid;
